import { FC, Fragment } from 'react';
import { useTranslation } from 'react-i18next';
import { TableCell, TableRow } from '@digdir/designsystemet-react';

import { OppvarmingGass } from '../../../../../../types/registration/userInput';
import {
  AccentedTableRow,
  Capitalize,
  LeftBorderCell
} from '../../../../../expertRegistration/json/enhet/upload/fileReview/components/styledComponents';

interface OppvarmingGassProps {
  gass: OppvarmingGass | undefined;
}
export const OppvarmingGassView: FC<OppvarmingGassProps> = ({ gass }) => {
  const { t } = useTranslation('', { keyPrefix: 'expertToolsJSON.summary.tekniskutstyr.oppvarming.gass' });
  const { t: tCommon } = useTranslation('', { keyPrefix: 'expertToolsJSON.summary.common' });

  return (
    gass && (
      <Fragment>
        <AccentedTableRow $isSecondarySection>
          <TableCell colSpan={2}>{t('header')}</TableCell>
        </AccentedTableRow>

        {gass.kamin && (
          <Fragment>
            <AccentedTableRow>
              <TableCell colSpan={2}>{t('kamin.label')}</TableCell>
            </AccentedTableRow>
            <TableRow>
              <TableCell>{t('kamin.termostatstyring.label')}</TableCell>
              <LeftBorderCell>{t(`kamin.termostatstyring.${gass.kamin.termostatstyring}`)}</LeftBorderCell>
            </TableRow>
          </Fragment>
        )}

        {gass.kjel && (
          <Fragment>
            <AccentedTableRow>
              <TableCell colSpan={2}>{t('kjel.label')}</TableCell>
            </AccentedTableRow>
            {gass.kjel.installasjonsAr && (
              <TableRow>
                <TableCell>{t('kjel.installasjonsar')}</TableCell>
                <LeftBorderCell>{gass.kjel.vetInstallasjonsAr ? gass.kjel.installasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: gass.kjel.installasjonsAr })}</LeftBorderCell>
              </TableRow>
            )}
            {gass.kjel.bruk && (
              <TableRow>
                <TableCell>{t('kjel.bruk.label')}</TableCell>
                <LeftBorderCell>{t(`kjel.bruk.${gass.kjel.bruk}`)}</LeftBorderCell>
              </TableRow>
            )}
            {gass.kjel.varmesystemBruk && (
              <TableRow>
                <TableCell>{t('kjel.varmesystembruk')}</TableCell>
                <LeftBorderCell><Capitalize>{gass.kjel.varmesystemBruk}</Capitalize></LeftBorderCell>
              </TableRow>
            )}
            {gass.kjel.gulvvarme && (
              <TableRow>
                <TableCell>{t('kjel.gulvvarme.label')}</TableCell>
                <LeftBorderCell>{t(`kjel.gulvvarme.${gass.kjel.gulvvarme}`)}</LeftBorderCell>
              </TableRow>
            )}
            {gass.kjel.radiator && (
              <TableRow>
                <TableCell>{t('kjel.radiator.label')}</TableCell>
                <LeftBorderCell>{t(`kjel.radiator.${gass.kjel.radiator}`)}</LeftBorderCell>
              </TableRow>
            )}
            {gass.kjel.varmesentral && (
              <TableRow>
                <TableCell>{t('kjel.varmesentral.label')}</TableCell>
                <LeftBorderCell>{t(`kjel.varmesentral.${gass.kjel.varmesentral}`)}</LeftBorderCell>
              </TableRow>
            ) &&
              gass.kjel.varmesentralInstallasjonsAr && (
                <TableRow>
                  <TableCell>{t('kjel.varmesentral.varmesentralInstallasjonsAr')}</TableCell>
                  <LeftBorderCell>{gass.kjel.vetVarmesentralInstallasjonsAr ? gass.kjel.varmesentralInstallasjonsAr : tCommon('innstallasjonsArUkjent', { byggAr: gass.kjel.varmesentralInstallasjonsAr })}</LeftBorderCell>
                </TableRow>
              )}
            {gass.kjel.serviceGjennomfortSiste2Ar && (
              <TableRow>
                <TableCell>{t('kjel.serviceGjennomfortSiste2Ar')}</TableCell>
                <LeftBorderCell>{t(`kjel.${gass.kjel.serviceGjennomfortSiste2Ar}`)}</LeftBorderCell>
              </TableRow>
            )}
          </Fragment>
        )}
      </Fragment>
    )
  );
};
